import { Request } from 'components/Request';

// Local stacks run with an empty STRIPE_PUBLIC_KEY, and Checkout opens an
// alert from checkout.stripe.com when handed no key.
const NOT_CONFIGURED = 'Card payments aren\'t set up on this server.';

// Opens Stripe Checkout for one product and charges it. Resolves with the
// server's response, or null when the buyer closes Checkout without paying.
export function stripeCheckout({ product, amount, description, gifted = null }) {
	if(!window.stripePublicKey) {
		return Promise.reject(new Error(NOT_CONFIGURED));
	}
	return new Promise((resolve, reject) => {
		let tokenReceived = false;
		const handler = StripeCheckout.configure({
			key: window.stripePublicKey,
			image: `${window.siteUrl}/images/smash/tiers/grandsmasher.png`,
			locale: 'auto',
			token: (token) => {
				tokenReceived = true;
				Request.post(`${window.siteUrl}/stripe_payment/player_payment`, { token, type: product, amount, gifted, json: true })
					.then((response) => {
						if(response && response.success) {
							resolve(response);
							return;
						}
						reject(new Error((response && (response.error || response.message)) || 'There was an error! Please try again later.'));
					})
					.catch(reject);
			},
			closed: () => {
				if(!tokenReceived) {
					resolve(null);
				}
			},
		});
		handler.open({ name: 'Smashladder', description, amount });
	});
}
